import ApiInstance from "../utils/instance";

export const LoginService = async (params) => {
    const formData = new URLSearchParams(); 
    for (const key in params) {
        formData.append(key, params[key]);
    }

    return await ApiInstance.post('/auth/login', formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
};

export const AuthTokenCheck = async () => {

};